import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { TreeItem, TreeviewComponent, TreeviewI18n, TreeviewItem } from '@soy-andrey-semyonov/ngx-treeview';
import { Observable, Subscription } from 'rxjs';
import { SimpleDataTreeviewI18n } from 'src/app/forms/simple-datatree/simple-datatree-i18n';
import { HTTPService } from 'src/app/services/http.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ButtonList } from 'src/app/system-utils/actions-buttons/actions-buttons.component';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { ThemeService } from 'src/app/services/theme.service';
import { GlobalErrorHandler } from 'src/app/services/GloabalErrorHandler.services';



@Component({
    selector: 'tiktok-brand',
    templateUrl: './tiktok-brand.component.html',
    styleUrl: './tiktok-brand.component.scss',
    standalone: false
})

export class TiktokBrandComponent  implements OnInit, OnDestroy {
  codecompany: any;
  sub:Subscription;
  buttonList:ButtonList[] = [];
  sub1:Subscription;
  category_id: any;
  pagedRows:any[]=[];
  pageIndex:number = 1;
  pageSize:number = 20;
  name;
  authrorized = 0;
  filteredPagedRows:any[]=[];
  loading:boolean = false;




  sortOrder: 'ascend' | 'descend' | null = null;

  nameSort = (a: any, b: any) =>{
      return a.name.localeCompare(b.name);
  }

  idSort = (a: any, b: any) =>{
      return a.id.localeCompare(b.id);
  }

  brand_statusSort = (a: any, b: any) =>{
      return a.brand_status.localeCompare(b.brand_status);
  } 

  authorized_statusSort = (a: any, b: any) =>{
      return a.authorized_status.localeCompare(b.authorized_status);
  } 
  
  constructor(private http:HTTPService, private uid:UserAuthenticationServices , private cd:ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data, public ThemeService:ThemeService,public dialogRef:MatDialogRef<any>, private spinner:NgxSpinnerService) { }


  editRow(evento){
    this.dialogRef.close(evento.id);

  }

  onFilterChange(){
    let filtered = [];

    if ( this.pagedRows.length> 0 ){
      filtered = this.pagedRows.filter(p =>
         p.name.toLowerCase().includes(this.name.toLowerCase())
      );
    }

    
    if ( filtered.length > 0 ){
      this.filteredPagedRows = filtered;
    }else{
      this.findBrands(this.name,this.authrorized);
    }      
  }

  onClickLine(evento){
      
  }


  okFunction(){
    this.dialogRef.close();
  }

  ngOnInit(): void {
    let formControl = (this.data as UntypedFormGroup);
    this.codecompany = formControl.get('CODECOMPANY').value;
    this.category_id = formControl.get('CATEGORY_ID').value;
    
    if ( this.codecompany == null || this.category_id == null){
        this.dialogRef.close();
        throw  Error("Selecionar a empresa e categoria para buscar marcas.");
    }
    
    this.buttonList.push({
      color:"warn",
      description:"Sair",
      action: ()=>{
          this.okFunction();
      }
    })

    //this.findBrands(null, this.authrorized);
    
  }

  onSwitch(evento){
    if( evento) {
      this.authrorized  = 1;
    }else{
      this.authrorized = 0;
    }

    this.findBrands(this.name,this.authrorized);
  }

  findBrands(name?:string, authorized:number=1){   
    
    this.loading = true;

    let ob = {
      "expressao": "getRequestData(GetBrands,Product,{@PARAMETER},GET,null,{@HEADER},{@CODEMKTP})",
      "novo": true,
      "codecompany": this.codecompany,
      "codemktp": 148,
      "codecontract": 0,
      "values":[] 
    }

    let header = {
      key:'@HEADER',
      value:`x-tts-access-token: {@MKTPACTIVECOMPANIES.ACESSTOKEN};content-type: application/json`
    }

    if ( name != null ){
      let parameters = {
        key:'@PARAMETER',
        value: '?shop_cipher={@MKTPACTIVECOMPANIES.SIGNATUREMETHOD}&brand_name=encodeString('+name+')&page_size=20&is_authorized='+authorized+'&category_id='+this.category_id+'&signTikTok({@CODECOMPANY},{@MKTPSERVICES.URL}?shop_cipher={@MKTPACTIVECOMPANIES.SIGNATUREMETHOD}&brand_name=encodeString('+name+')&page_size=20&is_authorized='+authorized+'&category_id='+this.category_id+',null)'
      }
      ob['values'].push(parameters);
    }else{
      let parameters = {
        key:'@PARAMETER',
        value: '?shop_cipher={@MKTPACTIVECOMPANIES.SIGNATUREMETHOD}&page_size=100&is_authorized='+authorized+'&category_id='+this.category_id+'&signTikTok({@CODECOMPANY},{@MKTPSERVICES.URL}?shop_cipher={@MKTPACTIVECOMPANIES.SIGNATUREMETHOD}&page_size=100&is_authorized='+authorized+'&category_id='+this.category_id+',null)'
      }
      ob['values'].push(parameters);
    }
    
    let keepParam = {
              key:'keepParam',
              value: true
    }

    ob['values'].push(header);
    
    ob['values'].push(keepParam);
    this.pagedRows = [];
    this.filteredPagedRows = [];
    this.sub = this.http.post(ob,'FormulaServices/test', true,true,false, false).subscribe(
      {
        next:(data)=>{
          let resultado = JSON.parse(data['resultado']);
          if ( resultado ){
              let data = resultado['data'];
              if ( data ){
                let brands = data['brands'];
                if ( brands != null ){
                  this.pagedRows = brands;
                  this.filteredPagedRows = brands;
                }
              }
          }
          this.loading = false;
        },
        error:(error)=>{
          this.loading = false;
          GlobalErrorHandler.showError(error);
        },
        complete:()=>{
            this.cd.detectChanges();
        }
    })
  }


  trackById(index: number, item: any): any {
    return item.id;
  }

  ngOnDestroy(){
    if ( this.sub!= null ){ this.sub.unsubscribe()};
    if ( this.sub1!= null ){ this.sub1.unsubscribe()};
  }
}
